import { ComponentRef, ElementRef, InjectionToken, ViewContainerRef } from '@angular/core';

export type RtButtonVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'outline'
  | 'plain'
  | 'success'
  | 'error'
  | 'warning';

export type RtButtonColorContextVariant =
  | 'outline-ghost'
  | 'plain-ghost'
  | 'plain-onoverlay'
  | 'plain-active';

export type RtPlanButtonVariant = 'launch' | 'scale' | 'lead' | 'start' | 'grow' | 'optimize';

export type RtInfoboxButtonVariant =
  | 'outline-informative'
  | 'outline-success'
  | 'outline-warning'
  | 'outline-error';

export type RtAddNewButtonVariant = 'rounded' | 'wide';

export type RtIconButtonVariant = 'transparent-light' | 'transparent-dark';

export const setInputs = <
  T extends ComponentRef<any>,
  U extends { [k in keyof T['instance']]: T['instance'][k] },
>(
  componentRef: T,
  props: Partial<U>,
) => {
  const { changeDetectorRef } = componentRef;
  Object.entries(props).forEach(([prop, value]) => componentRef.setInput(prop, value));
  changeDetectorRef.detectChanges();
};

export abstract class ExtendableButton {
  public prefix: ViewContainerRef;
  public suffix: ViewContainerRef;
  public elRef: ElementRef;
}

export const ExtendableButtonToken = new InjectionToken<ExtendableButton>('ExtendableButton');
